var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"该功能将在后续主干迭代中开放"}})
}
var staticRenderFns = []

export { render, staticRenderFns }